import React, { FC } from 'react';
import { FastField, FieldAttributes, FieldProps, FieldProps as FormikFieldProps } from 'formik';

import { ReadViewFunction, InputVisualizacaoRender } from "./InputVisualizacaoRender";
import { LoadingTexto } from '../Tipografia/Texto';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';
import Spinner from '@atlaskit/spinner';
import './input.scss'


export interface InputProps extends FieldAttributes<any> {
  /** Visualização do componente quando a operação do formulário é `OperacaoFormulario.Visualizar` 
   * ou quando o item está desabilitado */
  readView?: ReadViewFunction;
  /**
   * Caso o formulário esteja em `OperacaoFormulario.Visualizar` e o campo tenha a permissão
   * `RestricaoCRUD.alterar`, o campo será editado no contexto. Quando a pessoa confirmar o novo valor, 
   * esta função será chamada. Utilize-a para salvar o dado no banco de dados. */
  onConfirm?: (newValue: any) => {}
}


export const Input: React.FC<InputProps> = (props) => {
  const restricaoProps = useCampoFormularioProps(props.name, undefined);
  
  if (restricaoProps.hidden)
    return <></>
  
  if (restricaoProps.readOnly) {
    return (
      <FastField {...props}>
        {(formikProps: FormikFieldProps) => <ConteudoVisualizacao {...props} formikProps={formikProps} />}
      </FastField>
    )
  }

  // Obs: não passar {...restricaoProps} no FastField, senão o campo não funciona adequadamente
  return <FastField {...props} />
  // Desabilitado por questões de desempenho
  // return <FastField name={props.name}>
  //   {(formikProps: FormikFieldProps) => <ConteudoEdicao formikProps={formikProps} />}
  // </FastField>
}


interface ConteudoProps extends FieldAttributes<any> {
  formikProps: FieldProps;
}

const ConteudoVisualizacao: FC<ConteudoProps> = ({formikProps, ...props}) => {
  const restricaoProps = useCampoFormularioProps(props.name, undefined);
  const valor = formikProps.meta.value;
  const hasValor = valor !== undefined && valor.trim() !== "";
  const carregando = restricaoProps.loading === true;

  if (!hasValor && carregando) {
    return <LoadingTexto width={120} />
  }
  
  const texto = InputVisualizacaoRender.get(props.type)(props, formikProps)

  return <div className={props.className}>{texto}{carregando && <> <Spinner /></>}</div>
}

// const ConteudoEdicao: FC<ConteudoProps> = ({formikProps, ...props}) => {
//   const restricaoProps = useCampoFormularioProps(props.name, undefined);

//   return <input
//     {...formikProps.field}
//     disabled={formikProps.form.isSubmitting || restricaoProps.disabled}
//   />
// }